module.exports = {"513228100":"芦花镇","513228101":"卡龙镇","513228102":"色尔古镇","513228200":"沙石多乡","513228201":"红岩乡","513228202":"麻窝乡","513228203":"双溜索乡","513228204":"瓦钵梁子乡","513228206":"石碉楼乡","513228207":"龙坝乡","513228208":"洛多乡","513228209":"木苏乡","513228210":"维古乡","513228211":"知木林乡","513228212":"扎窝乡","513228213":"晴朗乡","513228214":"慈坝乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513228.json
// module id = 2406
// module chunks = 0